import type { ShippingDestinationsMap } from "@/components/Checkout/Information/utils";

export const WUILT_SHIPMENT_EGYPT_ID = "Country_clzy5vtku0000kn9kagau94vi";
export const Old_Shipping_Egypt_Id = "Country_cl0pf3jxc00m1lwm1hw3u66ri";

export interface ShippingDestination {
  country?: { value: string; label: string } | null;
  state?: { value: string; label: string } | null;
  city?: { value: string; label: string } | null;
  region?: { value: string; label: string } | null;
  isValid?: boolean;
}

export function getShippingDestinationOptions(
  shippingDestinationsMap: ShippingDestinationsMap,
  parentId?: string,
  isWuiltShipment?: boolean | null
): { value: string; label: string }[] {
  if (parentId) {
    const shippingDestinationsOptions = shippingDestinationsMap
      .get(parentId)
      ?.children?.map((id) => ({
        value: id!,
        label: shippingDestinationsMap.get(id)?.name!,
      }));
    const sorted = shippingDestinationsOptions?.sort((a, b) =>
      a.label.localeCompare(b.label)
    );
    return sorted ?? [];
  }

  const options: { value: string; label: string }[] = [];
  shippingDestinationsMap.forEach((item) => {
    if (!item?.parentId) {
      if (!isWuiltShipment) {
        options.push({ label: item?.name!, value: item?.id! });
      } else if (
        item?.name !== "Egypt" ||
        item?.id === WUILT_SHIPMENT_EGYPT_ID
      ) {
        options.push({ label: item?.name!, value: item?.id! });
      }
    }
  });
  return options.sort((a, b) => a.label.localeCompare(b.label));
}
